import React, { useEffect, useState } from 'react';
import InputField from '../../../../../component/form/FormInput';
import Navigation from './Navigation';
import OtherDetails from './OtherDetails';
import Address from './Address';
import CustomerDocuments from './customerDocuments';
import { useParams } from 'react-router-dom';
import InputSelect from '../../../../../component/inputSelect/InputSelect';

const CustomerForm = ({
	setCustomerData,
	setPrescriptionsDocsList,
	prescriptionsDocsList,
	customerData,
	cityList,
	customerDocs,
	setCustomerDocs,
	errors,
	setError,
	isEdit = false,
}) => {
	const [activeTab, setActiveTab] = useState('Other Details');
	const param = useParams();
	const id = param?.id;

	const [customerDisplayNameList, setCustomerDisplayNameList] = useState([]);

	const validateEmail = (value) => {
		const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return regex.test(value);
	};

	const handleCustomerBasicDetails = (type, value) => {
		setCustomerData((prev) => ({
			...prev,
			basicDetails: {
				...prev.basicDetails,
				[type]: type === 'customer_type' ? Number(value) : value,
			},
		}));
		var customerError = { ...errors };
		if (type === 'customer_phone_work' || type === 'customer_phone_mobile') {
			if (value) {
				if (value.length > 10 || value.length < 10) {
					customerError[type] =
						`Please enter valid ${type === 'customer_phone_work' ? 'Phone Work' : 'Phone Mobile'} number`;
				} else {
					delete customerError[type];
				}
			} else {
				delete customerError[type];
			}
		}
		if (type === 'customer_email') {
			if (value) {
				if (validateEmail(value)) {
					delete customerError[type];
				} else {
					customerError[type] = 'Please enter valid email address';
				}
			} else {
				delete customerError[type];
			}
		}
		setError(customerError);
	};

	const handleCustomerName = (type, value) => {
		if (type === 'customer_name' && customerData.basicDetails.customer_type === 0) {
			setCustomerData((prev) => ({
				...prev,
				basicDetails: {
					...prev.basicDetails,
					[type]: value,
					customer_display_name: value,
				},
			}));
		} else {
			setCustomerData((prev) => ({
				...prev,
				basicDetails: {
					...prev.basicDetails,
					[type]: value,
				},
			}));
		}
		var errorData = { ...errors };
		if (type === 'customer_name' && (value === '' || value === undefined)) {
			errorData['customer_name'] = 'Please enter customer name in the field';
		} else {
			delete errorData['customer_name'];
			delete errorData['customer_display_name'];
		}
		if (type === 'customer_display_name' && (value === '' || value === undefined)) {
			errorData['customer_display_name'] = 'Please enter customer display name in the field';
		} else {
			delete errorData['customer_display_name'];
		}
		setError(errorData);
	};

	const handleCustomerRemark = (key, value) => {
		setCustomerData((prev) => ({
			...prev,
			customerRemark: {
				[key]: value,
			},
		}));
	};

	const handleDisplayCustomerNameList = () => {
		const data = [
			{
				key: customerData.basicDetails.customer_name,
				value: customerData.basicDetails.customer_name,
			},
			{
				key: customerData.basicDetails.company_name,
				value: customerData.basicDetails.company_name,
			},
		];
		setCustomerDisplayNameList(data);
	};

	useEffect(() => {
		handleDisplayCustomerNameList();
	}, [customerData.basicDetails.customer_name, customerData.basicDetails.company_name]);

	return (
		<div className="max-w-1297 px-4 py-3">
			<div className="d-flex">
				<div
					className="col-6"
					style={{ paddingBottom: '9px', paddingLeft: '0px', paddingRight: '0px' }}
				>
					<label
						style={{
							fontWeight: 'bold',
							marginBottom: '1.3rem',
							display: 'block',
						}}
					>
						Customers Type
					</label>
					{isEdit ? (
						<label
							style={{
								marginRight: '1.5rem',
								display: 'flex',
								alignItems: 'center',
							}}
						>
							<input
								type="radio"
								autoComplete="off"
								checked={true}
								style={{
									cursor: 'pointer',
									marginRight: '0.75rem',
									width: '20px',
									height: '20px',
									borderRadius: '10px',
								}}
							/>
							{customerData.basicDetails.customer_type === 0 ? 'Individual' : 'Business'}
						</label>
					) : (
						<div style={{ display: 'flex', gap: '40px' }}>
							<label
								style={{
									marginRight: '1.5rem',
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<input
									type="radio"
									autoComplete="off"
									value={0}
									checked={customerData.basicDetails.customer_type === 0}
									onChange={(e) => {
										const value = e.target.value;
										handleCustomerBasicDetails('customer_type', value);
									}}
									style={{
										cursor: 'pointer',
										marginRight: '0.75rem',
										width: '20px',
										height: '20px',
										borderRadius: '10px',
									}}
								/>
								Individual
							</label>
							<label
								style={{
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<input
									type="radio"
									autoComplete="off"
									value={1}
									checked={customerData.basicDetails.customer_type === 1}
									onChange={(e) => {
										const value = e.target.value;
										handleCustomerBasicDetails('customer_type', value);
									}}
									style={{
										cursor: 'pointer',
										marginRight: '0.75rem',
										width: '20px',
										height: '20px',
										borderRadius: '10px',
									}}
								/>
								Business
							</label>
						</div>
					)}
				</div>

				{customerData.basicDetails.customer_type === 1 && (
					<div className="col">
						<InputField
							label="Company Name"
							placeholder="Company Name"
							type="text"
							value={customerData.basicDetails.company_name}
							onChange={(value) => handleCustomerBasicDetails('company_name', value)}
							disabled={isEdit}
							required={true}
							error={errors.company_name}
						/>
					</div>
				)}
			</div>
			<div className="row">
				<div className="col-6">
					<div style={{ position: 'relative' }}>
						<InputField
							label="Customer Name"
							placeholder="Customer Name"
							autoComplete="off"
							type="text"
							value={customerData.basicDetails.customer_name}
							onChange={(valueData) => {
								const value = valueData.replace(/[^A-Za-z\s']/g, '');
								handleCustomerName('customer_name', value);
							}}
							required={true}
							disabled={isEdit}
							error={errors.customer_name}
						/>
					</div>
				</div>
				<div className="col-6">
					{customerData.basicDetails.customer_type === 1 ? (
						<InputSelect
							options={customerDisplayNameList || []}
							placeholder="Select Customer Display Name"
							label="Customer Display Name"
							autoComplete="off"
							onChange={(value) => {
								if (value === null || value === '') {
									handleCustomerName('customer_display_name', value);
								}
							}}
							onSelect={(value) => handleCustomerName('customer_display_name', value.key)}
							value={customerData.basicDetails.customer_display_name}
							disabled={isEdit}
							required={true}
							error={errors?.customer_display_name}
						/>
					) : (
						<InputField
							label="Customer Display Name"
							placeholder="Customer Display Name"
							autoComplete="off"
							type="text"
							value={customerData.basicDetails.customer_display_name}
							onChange={(value) => handleCustomerName('customer_display_name', value)}
							required={true}
							disabled={isEdit}
							error={errors.customer_display_name}
						/>
					)}
				</div>
			</div>
			<div
				className="row"
				style={{ marginTop: '10px' }}
			>
				<div className="col-6">
					<InputField
						label="Customer Email"
						placeholder="Customer Email"
						autoComplete="off"
						value={customerData.basicDetails.customer_email}
						onChange={(value) => handleCustomerBasicDetails('customer_email', value)}
						type="text"
						disabled={isEdit}
						error={errors.customer_email}
					/>
				</div>
				{customerData.basicDetails.customer_type === 1 && (
					<div className="col-2">
						<InputField
							label="Phone(Work)"
							placeholder="Phone(Work)"
							autoComplete="off"
							maxLength={10}
							value={customerData.basicDetails.customer_phone_work}
							onChange={(valueData) => {
								var value = valueData?.replace(/[^0-9]/g, '');
								handleCustomerBasicDetails('customer_phone_work', value);
							}}
							type="text"
							style={{ textAlign: 'left' }}
							disabled={isEdit}
							error={errors.customer_phone_work}
						/>
					</div>
				)}
				<div className={customerData.basicDetails.customer_type === 0 ? 'col-4' : 'col-2'}>
					<InputField
						label="Phone(Mobile)"
						placeholder="Mobile Number"
						autoComplete="off"
						type="text"
						maxLength={10}
						value={customerData.basicDetails.customer_phone_mobile}
						onChange={(valueData) => {
							var value = valueData?.replace(/[^0-9]/g, '');
							handleCustomerBasicDetails('customer_phone_mobile', value);
						}}
						style={{ textAlign: 'left' }}
						disabled={isEdit}
						error={errors.customer_phone_mobile}
					/>
				</div>
				<div className="col-2">
					<InputField
						label="Credit Days"
						autoComplete="off"
						placeholder="0"
						value={customerData.basicDetails.customer_credit_days}
						onChange={(valueData) => {
							var value = valueData?.replace(/[^0-9]/g, '');
							handleCustomerBasicDetails('customer_credit_days', value);
						}}
						type="text"
						style={{ textAlign: 'right' }}
						disabled={isEdit}
					/>
				</div>
			</div>
			<Navigation
				activeTab={activeTab}
				setActiveTab={setActiveTab}
			/>
			{activeTab === 'Other Details' && (
				<OtherDetails
					customerType={customerData.basicDetails.customer_type}
					data={customerData.othersDetails}
					setCustomerData={setCustomerData}
					disabled={isEdit}
					error={errors}
					setError={setError}
				/>
			)}
			{activeTab === 'Address' && (
				<Address
					data={customerData.address}
					setData={setCustomerData}
					error={errors}
					cityList={cityList}
					disabled={isEdit}
				/>
			)}
			{activeTab === 'Remarks' && (
				<InputField
					label="Remark"
					placeholder="Remark"
					autoComplete="off"
					value={customerData.customerRemark.remark_text}
					onChange={(value) => handleCustomerRemark('remark_text', value)}
					type="text"
				/>
			)}
			{activeTab === 'Upload Documents' && (
				<CustomerDocuments
					setCustomerDocs={setCustomerDocs}
					customerDocs={customerDocs}
					customerId={id}
					customerType={customerData.basicDetails.customer_type}
					setPrescriptionsDocsList={setPrescriptionsDocsList}
					prescriptionsDocsList={prescriptionsDocsList}
				/>
			)}
		</div>
	);
};
export default CustomerForm;
